<template>
  <b-modal
    id="my-modal2"
    centered
    title="Producto"
    size="lg"
    hide-header
    hide-footer
    class="animated fadeIn"
  >
    <span class="icono-salir" @click="$bvModal.hide('my-modal2')">
      <i class="fas fa-times"></i>
    </span>
    <div v-for="(item,index) in modalProducto" :key="index" class="row w-100 mx-auto px-2 pb-3">
      <div class="col-12 text-center">
        <h1 class="m-0">{{item.nombre}}</h1>
        <h2 class="pb-2">{{item.descripcion}}</h2>
        <img :src="item.imagenPortafolio" width="400" class="img-fluid" />
        <br />
        <div>
          <router-link
          :to="'/'+item.path"
          class="mx-2 btn btn-light bg-primary text-white mt-3"
          title="Ver Producto"
        >Ver Producto</router-link>
        <div @click="$bvModal.hide('my-modal2')" class="btn btn-secondary mt-3">Cerrar </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["modalProducto"])
  }
};
</script>
<style scoped>
h1,
h2,
.icono-salir {
  font-family: "Nunito", sans-serif !important;
}
h1 {
  color: #262626;
  
  font-size: calc(1.4em + 1vw);
}
h2 {
  font-size: calc(1.1em + 0.5vw);
  color: #595959;
}
.icono-salir {
  float: right;
  color: #cecedb;
  cursor: pointer;
}
</style>
